import { withLazy } from '@/components/Lazy';
export const UserInfo = withLazy(() => import( '.').then((res) => res._UserInfo));
